import $ from "jquery";

window.addEventListener('DOMContentLoaded', () => {
  const mainHeader = document.querySelector('.main-header'),
    langSwitcher = mainHeader.querySelector('[data-bs-toggle="popover"]'),
    desktopMainNavTopbar = mainHeader.querySelector('nav.navbar'),
    anchorNav = document.querySelector('.navbar-scrollspy'),
    mainMenuNavbar = document.getElementById('navbarUPB'), // Main menu large popup navigation
    mainActions = mainHeader.querySelector('.navbar-actions_main'),
    mainActionsItems = mainActions.querySelector('.navbar-actions_main-items');

  let openHeaderContext,
    scrollDown = false,
    windowWidth = document.body.clientWidth;

  if(langSwitcher) initLangPopover();

  function transformMainHeader() {
    let transformMainHeaderValue = 0,
      transformAnchorNavValue = 0,
      transformMainActionValue = 0,
      transformMainActionInnerValue = 0;

    if(openHeaderContext){
      setTransforms();
      return;
    }

    const mainHeaderHeight = Math.round(mainHeader.offsetHeight);
    if(anchorNav){
      const anchorNavTop = anchorNav.getBoundingClientRect().top,
        anchorNavHeight = Math.round(anchorNav.getBoundingClientRect().height)
  
      //point where main-header and anchorNav collide
      if(anchorNavTop <= mainHeaderHeight) {
        //move header up by anchorNavTop but not more than mainHeaderHeight
        if(mainHeaderHeight - anchorNavTop < mainHeaderHeight)
          transformMainHeaderValue = - (mainHeaderHeight - anchorNavTop)
        else
          transformMainHeaderValue = - mainHeaderHeight
      }
  
  
      let removeHidden = true;
      if(scrollDown){
        if(anchorNavTop <= 0){
          transformAnchorNavValue = -anchorNavHeight;
          transformMainActionInnerValue = transformAnchorNavValue;
          removeHidden = false;
        }
      }
      // Reduces dom manipulations of already applied changes
      if(removeHidden){
        if(anchorNav.classList.contains('hidden')){
          anchorNav.classList.remove('hidden');
        }
      }else{
        if( ! anchorNav.classList.contains('hidden')){
          anchorNav.classList.add('hidden');
        }
      }
  
      //if no anchorNav items
      if(!anchorNav.querySelector('.nav-link')) {
        if(!scrollDown && transformMainHeaderValue < 0) {
            transformMainHeaderValue = 0;
            mainHeader.style.transition = 'transform 0.3s';
        }
        setTransforms();
        return;
      }

      //move main-actions up by the same amount as main-header
      let heightDiffHeaderAndAnchorNav = mainHeaderHeight - anchorNavHeight;
      transformMainActionValue = - (transformMainHeaderValue + (getPercantageOfMainActionMoveUp() * (heightDiffHeaderAndAnchorNav / 2)));
  
      //set css variables for navbar-actions_main
      let mainActionsLeft = Math.ceil(mainActions.getBoundingClientRect().left + window.scrollX),
        headerNavbarStyles = window.getComputedStyle(mainHeader.querySelector('.navbar')),
        paddingDiffHeaderY = parseInt(headerNavbarStyles.paddingTop,10) - parseInt(headerNavbarStyles.paddingBottom,10);
      mainActions.style.setProperty('--bg-width', `${Math.floor(windowWidth) - mainActionsLeft}px`);
      mainActions.style.setProperty('--bg-height', `${mainHeaderHeight + (getPercantageOfMainActionMoveUp() * -heightDiffHeaderAndAnchorNav)}px`);
      mainActions.style.setProperty('--bg-top-offset', `${paddingDiffHeaderY/2}px`);
    }

    function getPercantageOfMainActionMoveUp(){
      return -(transformMainHeaderValue / mainHeaderHeight);
    }

    let navbarScroll0 = document.getElementById("navbarScroll-0");
    function setTransforms(){
      mainHeader.style.transform = `translateY(${transformMainHeaderValue}px)`;
      if(anchorNav){
        anchorNav.style.transform = `translateY(${transformAnchorNavValue}px)`;
        mainActions.style.transform = `translateY(${transformMainActionValue}px)`;
        mainActionsItems.style.transform = `translateY(${transformMainActionInnerValue}px)`;
        if(navbarScroll0){
          if(transformMainActionValue > 0){
            navbarScroll0.classList.add('shrink');
            navbarScroll0.classList.remove('stretch');
          }else{
            navbarScroll0.classList.add('stretch'); 
            navbarScroll0.classList.remove('shrink');
          }
        }
      }
    }

    setTransforms();
  }

  window.addEventListener('scroll', transformMainHeader);

  let offsetScollCounts = 0;
  if($('section.stage').length > 0){
    offsetScollCounts = $('section.stage').offset().top + $('section.stage').height();
  }

  let lastScollPosition = window.scrollY,
    lastScrollHeight = document.body.scrollHeight,
    lastScrollShowHideSwitch = offsetScollCounts;

  /**
   * Adds class "scrolled" to stage header - Controls the animation of the big decor elements flying in/out
   * Adds class "scoll-down/up" to control hide navbar with a delay
   * Avoids "scroll-down"-hide delay when scrolling down by clicking on an anchor ("scroll-click")
   */
  let sectionStage = document.querySelector('section.stage');
  window.addEventListener('scroll', function(){

    //let delayHideByScroll = 1000;
    let delayHideByScroll = document.body.scrollHeight / 8;
    let stageAnimationDelay = Math.round(sectionStage.offsetHeight) / 8;

    //throttle to run only every 100ms
    if(!this.throttleScroll){
      this.throttleScroll = setTimeout(() => {

        if(mainHeader.classList.contains('scroll-click')){
          document.body.classList.remove('scrolled');
          scrollDown = false;
          mainHeader.classList.remove('scroll-down');
        }else{
          if(globalThis.lastScrollToAnchorPos){
            globalThis.lastScrollToAnchorPos = false;
          }else{
        
            if(window.scrollY > stageAnimationDelay){
              document.body.classList.add('scrolled');
            }else{
              document.body.classList.remove('scrolled');
            }

            //get difference between last scrollHeight and current scrollHeight
            let differenceInScrollHeight = document.body.scrollHeight - lastScrollHeight;

            if(window.scrollY - differenceInScrollHeight - offsetScollCounts > lastScrollShowHideSwitch + delayHideByScroll){
              scrollDown = true;
              mainHeader.classList.add('scroll-down');
            }

            if(window.scrollY - differenceInScrollHeight < lastScollPosition || window.scrollY == 0){
              lastScrollShowHideSwitch = window.scrollY;
              scrollDown = false;
              mainHeader.classList.remove('scroll-down');
            }
              
          }
            
        }

        lastScollPosition = window.scrollY;
        lastScrollHeight = document.body.scrollHeight;

        clearTimeout(this.throttleScroll);
        delete this.throttleScroll;
      }, 100);
    }
  });

  function initLangPopover() {
    let langPopup = document.getElementById('popover-content');

    new bootstrap.Popover(langSwitcher, {
      container: desktopMainNavTopbar,
      align: 'auto right',
      html: true,
      trigger: 'click',
      template: '<div class="popover popover-lang" role="tooltip"><div class="popover-body"></div></div>',
      content: langPopup,
    });

    let delay = (time) => {
      return new Promise(res => {
        setTimeout(res, time)
      });
    };

    let handlerFunc = (e) => { 
      const langSwitcherEle = bootstrap.Popover.getInstance(langSwitcher);
      
      // Popover generated wrapper
      let langPopupWrapper = langPopup.parentElement;

      // if(e.type == "blur"){
      //   langPopupWrapper = langPopup.parentElement.parentElement;
      //   if ($(langSwitcherEle).find(':focus').length !== 0 || $(langPopupWrapper).find(':focus').length !== 0) {
      //     e.stopPropagation();
      //     return false;
      //   }
      // }else 
      if(e.type == "scroll"){
        unregPopoverHandlers();
        delay(300).then(function(){
          langSwitcherEle.hide();
        });
        return true;
      }else if(e.type == "click"){
        const isClickInside = langSwitcher.contains(e.target) || langPopupWrapper.contains(e.target);
        if (isClickInside) {
          if(e.target.tagName != 'A'){
            e.stopPropagation();
            return false;
          }
        }
      }

      langSwitcherEle.hide();
      return true;
    };

    let unregPopoverHandlers = () => {
      document.removeEventListener('click', handlerFunc);
      window.removeEventListener("scroll", handlerFunc);
      //langSwitcher.removeEventListener("blur", handlerFunc);
    };
    langSwitcher.addEventListener("hide.bs.popover", unregPopoverHandlers);

    let regPopoverHandlers = () => {
      // Safari does not trigger (un)focus events on click = https://github.com/reactstrap/reactstrap/issues/1428
      // So trigger manual
      document.addEventListener("click", handlerFunc);
      window.addEventListener("scroll", handlerFunc);
      //langSwitcher.addEventListener("blur", handlerFunc);
    };
    langSwitcher.addEventListener("show.bs.popover", regPopoverHandlers);

    langSwitcher.addEventListener("show.bs.popover", function(){
      langPopup.classList.remove('d-none');
    }, { once: true });
  }

  function toggleHeaderContext(context) {
    let transform = true;

    // Change context or its a close (same icon clicked)
    if(openHeaderContext && mainHeader.classList.contains('open-context-'+openHeaderContext)){
      mainHeader.classList.remove('open-context-'+openHeaderContext);
    }

    if(mainHeader.classList.contains('open-context') && openHeaderContext === context){
      // Clicked closed
      mainHeader.classList.remove('open-context');
      //document.querySelector('body').classList.remove('overflow-hidden');
      openHeaderContext = null;
      // after closed transform back to sticky nav
    } else {
      // Open or changed context
      mainHeader.classList.add('open-context');
      if(context){
        mainHeader.classList.add('open-context-'+context);
      }
      //document.querySelector('body').classList.add('overflow-hidden');
      //transform = openHeaderContext || context != 'search';
      openHeaderContext = context;
    }

    if(transform){
      transformMainHeader();
    }
  }

  const searchCollapseBtnList = document.querySelectorAll('.navbar-button--collapse-search')
  const searchCollapse = new bootstrap.Collapse(document.getElementById('searchBarUPB'),{
    parent: mainHeader,
    toggle: false,
    hide: true
  });

  const menuCollapseBtnList = document.querySelectorAll('.navbar-button--collapse-menu')
  const navbarUPB = document.getElementById('navbarUPB');
  const menuCollapse = new bootstrap.Collapse(navbarUPB, {
    parent: mainHeader,
    toggle: false
  });
  // show.bs.collapse - immediate
  // shown.bs.collapse - after animation
  navbarUPB.addEventListener('show.bs.collapse', event => {
    document.body.style.overflowY = "hidden";
    _paq.push(['trackEvent', 'navigation', 'MainMenuClickOpen', '']);
  });
  // hide.bs.collapse - immediate
  // hidden.bs.collapse - after animation
  navbarUPB.addEventListener('hide.bs.collapse', event => {
    document.body.style.overflowY = "scroll";
    _paq.push(['trackEvent', 'navigation', 'MainMenuClickClose', '']);
  });

  const searchCollapseBtn = [...searchCollapseBtnList].map((collapseBtn) => {
    collapseBtn.addEventListener('click', function(){
      searchCollapse.toggle();
      toggleHeaderContext('search');
    })
  });
  const menuCollapseBtn = [...menuCollapseBtnList].map((collapseBtn) => {
    collapseBtn.addEventListener('click', function(){
      menuCollapse.toggle();
      toggleHeaderContext('menu');
    })
  });


  function initMenu(){
    let openSubMenus = [];

    const subMenuToggles = mainMenuNavbar.querySelectorAll('.toggle-submenu');
    //loop over subMenuToggles
    subMenuToggles.forEach((subMenuToggle, index) => {
      //set data-index attribute to subMenuToggle
      subMenuToggle.setAttribute('data-index', index);
      subMenuToggle.addEventListener('click', function(e){
        e.preventDefault();
        openSubMenu(subMenuToggle);
      });
    });

    //add event listener to .close-submenu and first breadcrumb button
    mainMenuNavbar.querySelector('.close-submenu').addEventListener('click', function(){
      closeSubMenu(openSubMenus[openSubMenus.length-1]);
    });
    mainMenuNavbar.querySelector('.breadcrumb li:first-child button').addEventListener('click', function(){
      closeSubMenu(openSubMenus[1]);
    });

    function openSubMenu(subMenuToggle){
      //switch subMenuToggle from .active-submenu to .main-menu
      if(subMenuToggle.closest('.active-submenu')){
        //select same subMenuToggle in .main-menu
        subMenuToggle = mainMenuNavbar.querySelector(`.toggle-submenu[data-index="${subMenuToggle.getAttribute('data-index')}"]`);
      }
      else{
        if(openSubMenus.length) closeSubMenu(openSubMenus[openSubMenus.length-1]);
      }
      if(!openSubMenus.length) mainMenuNavbar.classList.add('open-submenu');
      subMenuToggle.setAttribute('aria-expanded', true);
      //save current submenu
      openSubMenus.push(subMenuToggle);
      //copy ul into .active-submenu
      const subMenu = subMenuToggle.nextElementSibling.cloneNode(true);
      replaceActiveSubmenu(subMenu);

      //give parent ul .active-submenu-parent
      mainMenuNavbar.querySelector('.active-submenu-parent')?.classList.add('active-submenu-inside');
      mainMenuNavbar.querySelector('.active-submenu-inside')?.classList.remove('active-submenu-parent');
      subMenuToggle.parentElement.parentElement.classList.add('active-submenu-parent');
      //add breadcrumb point to .breadcrumb
      const breadcrumbEl = document.createElement('li');
      breadcrumbEl.innerHTML = '<button type="button">'+subMenuToggle.innerText+'</button>';
      mainMenuNavbar.querySelector('.breadcrumb').appendChild(breadcrumbEl);
      //add event listener to breadcrumb point
      breadcrumbEl.childNodes[0].addEventListener('click', function(){
        closeSubMenu(openSubMenus[openSubMenus.length - 1]);
      });
    }

    function closeSubMenu(subMenuToggle){
      const breadcrumbEls = mainMenuNavbar.querySelectorAll('.breadcrumb li');
      //loop over openSubMenus
      openSubMenus.forEach((openSubMenu, index) => {
        if(index >= openSubMenus.indexOf(subMenuToggle)){
          //remove aria-expanded from openSubMenus after current submenu
          openSubMenu.removeAttribute('aria-expanded');
          //remove breadcrumb point from .breadcrumb
          breadcrumbEls[index+1].remove();
        }
      });

      mainMenuNavbar.querySelector('.active-submenu-parent')?.classList.remove('active-submenu-parent');
      mainMenuNavbar.querySelector('.active-submenu').innerHTML = '';

      //remove from array
      openSubMenus.splice(openSubMenus.indexOf(subMenuToggle), openSubMenus.length - openSubMenus.indexOf(subMenuToggle));
      //if no more openSubMenus, remove class open-submenu from mainMenuNavbar
      if(!openSubMenus.length){
        mainMenuNavbar.classList.remove('open-submenu');
      }
      else{
        //give parent ul .active-submenu-parent
        openSubMenus[openSubMenus.length-1]?.parentElement.parentElement.classList.add('active-submenu-parent');
        //copy ul into .active-submenu
        const subMenu = openSubMenus[openSubMenus.length-1].nextElementSibling.cloneNode(true);
        replaceActiveSubmenu(subMenu);
      }
    }

    function replaceActiveSubmenu(newSubmenu){
      mainMenuNavbar.querySelector('.active-submenu').innerHTML = '';
      mainMenuNavbar.querySelector('.active-submenu').appendChild(newSubmenu);
      //add event listener to inner subMenuToggles
      newSubmenu.querySelectorAll('.toggle-submenu').forEach((subMenuToggle) => {
        subMenuToggle.addEventListener('click', function(e){
          e.preventDefault();
          openSubMenu(subMenuToggle);
        });
      });
    }

    function toggleMoreLinksOnDestkop(){
      if(window.innerWidth > 992){
        mainMenuNavbar.querySelectorAll('.more-links details').forEach((moreLink) => {
          moreLink.setAttribute('open', true);
        });
      }
      else{
        mainMenuNavbar.querySelectorAll('.more-links details').forEach((moreLink) => {
          moreLink.removeAttribute('open');
        });
      }
    }
    function alignLangPopOver(){
      //wait one tick
      setTimeout(() => {
        if(!document.querySelector('.popover-lang')) return;

        //.popover-lang translate: calc(-25% + 6px) 0; if there is enough space on the left
        const popoverLang = document.querySelector('.popover-lang');
        const popoverLangRect = popoverLang.getBoundingClientRect();

        if(popoverLangRect.left - popoverLangRect.width/2 > 0){
          popoverLang.style.translate = 'calc(-25% + 6px) 0';
        }
        else{
          popoverLang.style.translate = 'calc(25% - 6px) 0';
        }
      }, 0);
    }
    window.addEventListener('resize', function(){
      windowWidth = document.body.clientWidth;
      toggleMoreLinksOnDestkop();
      alignLangPopOver();
      transformMainHeader();
    });
    toggleMoreLinksOnDestkop();
    //when clicking on .lang-switch, align it to the left
    langSwitcher.addEventListener('click', function(){
      alignLangPopOver();
    });

  }
  initMenu()

});
